<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qkEhCM/tc-custom/9781633411432.jpg?1705018939994" alt="This image is the cover for the book Grimoire of Aleister Crowley"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grimoire of Aleister Crowley
      </h1>
      <p class="bookDescription body article font2">
        <b>A comprehensive presentation of group-oriented rites for modern magicians inspired by the occult works of Aleister Crowley.</b><br/><br/>Group ritual has been a cornerstone of spiritual practice since time immemorial, yet its history and importance have often been overlooked by occultists of the modern age. This book is an essential resource on the topic, featuring rituals written by Aleister Crowley for his own magic circles—many of them unpublished during his lifetime, plus rare ancient texts that were Crowley’s own inspiration.<br/><br/>The rituals are newly edited and explained by practicing magician Rodney Orpheus, drawing on his wealth of experience performing and teaching them within Crowley’s magical order, Ordo Templi Orientis. Orpheus introduces each ritual, explaining its historical context and its function and mode of operation. He also includes detailed notes on each ritual’s proper setting and performance.<br/><br/>Whether absolute beginner or seasoned expert, magicians of all paths will find this volume to be an eminently workable and extremely powerful grimoire spanning centuries from ancient Mithraic and Bacchanalian rites, Goetia, and Gnosticism, right up to present day Crowleyan invocations and sexual magick.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rodney Orpheus, Lon Milo DuQuette
      </h2>
      
      <p class="authorDescription body article">Rodney Orpheus is a practicing magician, an established musician, and a member of the band The Cassandra Complex, one of the most important electroindustrial bands of the past decade. He lives in London and travels extensively.    Aleister Crowley (1875-1947) was the most widely read author in 20th-century occultism. He single-handedly redefined magic as a field of inquiry and endeavor through his books and the order that he led--the A.A. and the O.T.O. He is the author several books including The Book of the Law, 777 & Other Qabalistic Writings, and The Book of Thoth.    Lon Milo DuQuette has been involved with occult studies since the late 60s, and has become an acknowledged and widely recognized authority within the world of modern occultism. His previous publications include Magick of Thelema, The Tarot of Ceremonial Magick, Angels, Demons & Gods of the New Millennium, and the humorous, biographical My Life with the Spirits.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Weiser Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?27b84421